export default __webpack_public_path__ + "static/media/appModeRemoteH.8982c0d4.png";